import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { GENERAL_REVIEWS, SPECIAL_REVIEWS } from "../../text-data";
const Div = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 2px;
  margin-right: 6px;
`;
const ChartSquare = ({ name }) => {
  const colorName = (name) => {
    switch (name) {
      case "1점":
        return "bg-chart-4";
      case "2점":
        return "bg-chart-3";
      case "3점":
        return "bg-chart-2";
      case SPECIAL_REVIEWS:
      case "4점":
        return "bg-chart-1";
      case GENERAL_REVIEWS:
      default:
        return "bg-chart-0";
    }
  }
  return <Div className={colorName(name)}></Div>;
  // return <Div className={`bg-chart-${index % 5}`}></Div>;
};
const Box = styled.div`
  padding: 12px 16px;
`;
const ChartLegend = ({ ls }) => {
  console.log(ls)
  return (
    <Box className="flex flex-col gap-2 text-normal bg-gray mt-6">
      {ls.map(([v1, v2, v3], index) => {
        return (
          <div key={uuidv4()} className="flex justify-between items-center">
            <div className="flex  items-center">
              {/* <ChartSquare index={index} /> */}
              <ChartSquare name={v1} />

              <span>{v1}</span>
            </div>
            <div>
              <b>{v2}</b>
              <span
                className="text-end"
                style={{ width: "60px", display: "inline-block" }}
              >
                {v3}
              </span>
            </div>
          </div>
        );
      })}
    </Box>
  );
};

export default ChartLegend;
